import InformationLogPage from './components/InformationLogPage';

const routes = [
  {
    path: '/information-log',
    name: 'menu.information',
    icon: 'information',
    customIcon: true,
    loginRequired: true,
    component: InformationLogPage,
    weight: 2,
    permission: [],
    children: [],
  },
];

export default routes;
